import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';
import { round } from 'mathjs';

import moStore, { toggleValue } from '@store/index';
import EffectService from '@service/effect';
import { newRate } from '@tool/index';

const moTrend = observable({
  type: 'chart', // chart, table
  empty: false,
  tabList: <string[]>['总薪酬成本占比', '各类员工薪酬占比'],
  tabActive: <string>'总薪酬成本占比',
  totalXLeftData: <any[]>[],
  totalXRightData: <any[]>[],
  totalYData: <any[]>[],
  staffXLeftData: <any[]>[],
  staffXRightData: <any[]>[],
  staffYData: <any[]>[],
  tableTitle: <any[]>[],
  tableList: <any[]>[],
  admin: <any[]>[],
  dev: <any[]>[],
  sale: <any[]>[],
  total: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  totalOverview: <any[]>[],
  categoryOverview: <any[]>[],
});

const trendInit = action((res: any) => {
  // console.log('薪酬成本投入 - 时间趋势 -- ', res);
  if (isEmpty(res)) {
    moTrend.empty = true;
    return;
  }
  if (isEmpty(res.admin) && isEmpty(res.develop) && isEmpty(res.sale) && isEmpty(res.total)) {
    moTrend.empty = true;
    return;
  }
  moTrend.empty = false;
  const totalXLeft: any[] = [];
  const totalXRight: any[] = [];
  const totalY: any[] = [];
  const adminArr: any[] = [];
  const devArr: any[] = [];
  const saleArr: any[] = [];
  const tableArr: any[] = [];

  res?.total?.map((item: any) => {
    totalY.unshift(item.year);
    totalXLeft.unshift(item.value);
    totalXRight.unshift(item.ratio);
    tableArr.push({
      year: item.year,
      value: [newRate(item.value), newRate(item.ratio)],
    });
  });
  res?.admin?.map((item: any) => adminArr.unshift(item.value));
  res?.sale?.map((item: any) => saleArr.unshift(item.value));
  res?.develop?.map((item: any) => devArr.unshift(item.value));

  res?.develop?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.year === child.year) {
        child.value.push(newRate(item.value));
      }
    });
  });
  res?.sale?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.year === child.year) {
        child.value.push(newRate(item.value));
      }
    });
  });
  res?.admin?.map((item: any) => {
    tableArr.map((child: any) => {
      if (item.year === child.year) {
        child.value.push(newRate(item.value));
      }
    });
  });
  const newArr: any[] = [];
  tableArr.map((item: any) => {
    const tempArr: any[] = [];
    tempArr.push(item.year);
    item.value.map((child: any) => {
      tempArr.push(child);
    });
    newArr.push(tempArr);
  });

  runInAction(() => {
    moTrend.totalXLeftData = totalXLeft;
    moTrend.totalXRightData = totalXRight;
    moTrend.totalYData = totalY;
    moTrend.total = res.total;
    moTrend.yData = totalY;
    moTrend.admin = adminArr;
    moTrend.dev = devArr;
    moTrend.sale = saleArr;
    moTrend.tableList = newArr;
    moTrend.overview = res.total_overview;
    moTrend.totalOverview = res.total_overview;
    moTrend.categoryOverview = res.category_overview;
    moTrend.tableTitle = ['年份', '薪酬成本占比', '占比变化', '研发类薪酬占比', '销售类薪酬占比', '管理类薪酬占比'];
    if (moTrend.tabActive === '各类员工薪酬占比') moTrend.overview = res.category_overview;
    else moTrend.overview = res.total_overview;
  });
});

const changeType = action((value: string) => {
  moTrend.type = value;
  localStorage.setItem('costTrendType', value);
});

const changeTab = action((val: string) => {
  moTrend.tabActive = val;
  localStorage.setItem('costTrendTab', val);
  if (val === '各类员工薪酬占比') moTrend.overview = moTrend.categoryOverview;
  else moTrend.overview = moTrend.totalOverview;
});

export default moTrend;
export {
  trendInit, changeTab, changeType,
};
